function initializeHeroPlaylist() {
    const marqueeElements = document.querySelectorAll('.auto-scroller-track');

    if (marqueeElements.length === 0) return;

    marqueeElements.forEach(marquee => {
        const speed = marquee.dataset.speed || 3;
        marquee.style.animationDuration = `${speed}s`;
    });

    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const marquee = entry.target.querySelector('.auto-scroller-track');
                if (marquee) {
                    if (entry.isIntersecting) {
                        marquee.style.animationPlayState = 'running';
                    } else {
                        marquee.style.animationPlayState = 'paused';
                    }
                }
            });
        }, {
            threshold: 0.1
        });

        document.querySelectorAll('.auto-scroller').forEach(section => {
            observer.observe(section);
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    initializeHeroPlaylist();
});

document.addEventListener('shopify:section:load', () => {
    initializeHeroPlaylist();
});